import React from 'react';
import useStyles from './styles';
import {Button} from "@material-ui/core";
import Loading from "../../../../Loading";
import {useHistory} from "react-router-dom";

function ConfirmacionSuccess(props) {
    const classes = useStyles();
    const isSuccess = props.response === 200
    const history = useHistory();

    const clickHandler = () => {
        history.push('/u/dashboard')
    }

    return (
        <React.Fragment>
            {!props.loading ?
                <>
                    <h3 className={classes.text}>
                        {isSuccess
                            ? "La emisión se confirmó exitosamente"
                            : "Hubo un problema al confirmar la emisión, por favor intentelo nuevamente"}
                    </h3>
                    <div className={classes.buttons}>
                        <Button
                            variant="contained"
                            onClick={clickHandler}
                            className={classes.buttonContained}>
                            Finalizar
                        </Button>
                    </div>
                </>
                :
                <Loading/>
            }
        </React.Fragment>
    );
}

export default ConfirmacionSuccess;
